import React from 'react';
import { Skeleton } from 'antd';

import OrderProduct from '@/common/components/order-product';

export default function OrderProductSkeleton() {
  return (
    <div className="flex  flex-col  justify-evenly ">
      <OrderProduct className="my-3 !h-[111px]">
        <Skeleton.Image
          className="small-image-skeleton !h-[72px] !w-[72px] self-start  justify-self-start "
          active
        />

        <OrderProduct.Container type="parent">
          <OrderProduct.Title onClick={() => {}} className="!h-[21px]">
            <Skeleton.Input active size="small" className="!h-5 !w-44" />
          </OrderProduct.Title>

          <OrderProduct.Container type="row" onClick={() => {}}>
            <OrderProduct.Container type="col">
              <OrderProduct.Properties>
                <Skeleton.Input active size="small" className="!h-4 !w-7" />{' '}
              </OrderProduct.Properties>

              <OrderProduct.Properties>
                <Skeleton.Input active size="small" className="!h-4 !w-7" />{' '}
              </OrderProduct.Properties>
            </OrderProduct.Container>

            {/* <OrderProduct.ProductPrice
              priceClassName="text-secondary-default font-semibold"
              discountClassName="text-secondary-300 font-normal"
              price={rialToToman(
                (productVariantPrice
                  ? Number(productVariantPrice) * productItem?.quantity
                  : 0) || 0,
                appConfigs.rialExchangeRate
              )}
              discount={Math.round(varinatDiscount * 100)}
            /> */}
          </OrderProduct.Container>
        </OrderProduct.Container>
      </OrderProduct>
    </div>
  );
}
